import React from 'react';
import ErrorCard from "./ErrorCard";

interface ErrorCardControllerProps
{
    
}

interface ErrorCardControllerState
{
    messages: string[];
}

export default class ErrorCardController extends React.Component<ErrorCardControllerProps, ErrorCardControllerState>
{
    state: ErrorCardControllerState = {
        messages: []
    }
    
    public addErrorMessage(message: string)
    {
        const newMessageList = this.state.messages;
        newMessageList.push(message);
        
        this.setState({
            messages: newMessageList,
        });
    }
    
    private handleErrorCardClose(message: string)
    {
        const newMessageList = this.state.messages
            .filter((x) => x !== message);

        this.setState({
            messages: newMessageList,
        });
    }
    
    render()
    {
        const { messages } = this.state;
        
        return (
            messages.map((message, index) =>
                <ErrorCard
                    key={`ErrorCard_${index}`}
                    message={message}
                    onClose={() => this.handleErrorCardClose(message)}
                />)
        );
    }
}